// Import root feature components here
import LandingPage from './landing/LandingPage.vue';
import MaintenanceMode from './system/maintenance/MaintenanceMode.vue';
import Dashboard from './dashboard/Dashboard.vue';
import Home3 from './home/Home3.vue';
import RemoteStream from './remotes/stream/RemoteStream.vue';
import Remotes from './remotes/Remotes.vue';
import Remote from './remotes/Remote.vue';
import Devices from './devices/Devices.vue';
import Device from './devices/Device.vue';
import Groups from './groups/Groups.vue';
import Group from './groups/Group.vue';
import Reports from './reports/Reports.vue';
import Api from './api/Api.vue';
import Admin from './admin/Admin.vue';
import Documentation from './documentation/Documentation.vue';
import Software from './software/Software.vue';
import Jobs from './jobs/Jobs.vue';
import JobPage from './jobs/JobPage.vue';
import Health from './system/Health.vue';
import LoadError from './system/LoadError.vue';
import Configurator from './configurator/Configurator.vue';

// Billing Integration routes
import Terminals from './terminals/Terminals.vue';
import Terminal from './terminals/Terminal.vue';
import Tools from './tools/Tools.vue';
import OptionsFileValidator from './tools/OptionsFileValidator.vue';
import Subscriptions2 from './subscriptions2/Subscriptions.vue';
import Subscription2 from './subscriptions2/Subscription.vue';

// Import Children route functions
import AdminRoutes from './admin/admin-routes';
import RemoteRoutes from './remotes/remote-routes';
import DeviceRoutes from './devices/device-routes';
import GroupRoutes from './groups/group-routes';
import DocumentationRoutes from './documentation/documentation-routes';
import SoftwareRoutes from './software/software-routes';
import JobRoutes from './jobs/job-routes';
import TerminalRoutes from './terminals/terminal-routes';
import Subscription2Routes from './subscriptions2/subscription2-routes';

// Function
export default function Routes(hasRole, hasFeature) {
  return [
    {
      path: '/',
      redirect: '/home',
      meta: { 
        authName: 'kppnext'
      }
    },
    {
      path: '/maintenance',
      components: {
        maintenance: MaintenanceMode
      },
      meta: { 
        public: true
      }
    },
    {
      path: '/welcome',
      name: 'welcome',
      components: {
        public: LandingPage
      },
      meta: {
        public: true,
        authName: 'kppnext'
      }
    },
    {
      path: '/configurator',
      name: 'configurator',
      components: {
        configurator: Configurator
      },
      meta: {
        public: true,
        authName: 'kppnext'
      }
    },
    {
      path: '/home',
      component: Home3,
      name: 'home',
      meta: { 
        authName: 'kppnext'
      }
    },
    {
      path: '/loadError',
      component: LoadError,
      meta: { 
        authName: 'kppnext'
      }
    },
    {
      path: '/dashboard',
      component: Dashboard,
      name: 'dashboard',
      meta: {
        authName: 'kppnext'
      }
    },
    {
      path: '/remotes',
      name: 'Remotes',
      components: {
        default: Remotes,
        detail: Remote
      },
      children: RemoteRoutes(hasRole, hasFeature),
      beforeEnter: (to, from, next) => {
        // eslint-disable-next-line no-unused-vars
        next(vm => (hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin,Credentialed') ? true : '/dashboard'))
      },
      meta: {
        authName: 'kppnext'
      }
    },
    {
      path: '/terminals',
      name: 'Terminals',
      components: {
        default: Terminals,
        detail: Terminal
      },
      children: TerminalRoutes(hasRole, hasFeature),
      beforeEnter: (to, from, next) => {
        // eslint-disable-next-line no-unused-vars
        next(vm => (hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin,Credentialed') ? true : '/dashboard'))
      },
      meta: {
        authName: 'kppnext'
      }
    },
    {
      path: '/stream',
      component: RemoteStream,
      name: 'remoteStream',
      beforeEnter: (to, from, next) => {
        // eslint-disable-next-line no-unused-vars
        next(vm => (hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin,Credentialed') ? true : '/dashboard'))
      },
      meta: {
        authName: 'kppnext'
      }
    },
    // {
    //   path: '/subscriptions',
    //   name: 'Subscriptions',
    //   components: {
    //     default: Subscriptions,
    //     detail: Subscription
    //   },
    //   children: SubscriptionRoutes(hasRole, hasFeature),
    //   beforeEnter: (to, from, next) => {
    //     // eslint-disable-next-line no-unused-vars
    //     next(vm => (hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin') ? true : '/dashboard'))
    //   },
    //   meta: {
    //     authName: 'kppnext'
    //   }
    // },
    {
      path: '/subscriptions',
      name: 'Subscriptions',
      components: {
        default: Subscriptions2,
        detail: Subscription2
      },
      children: Subscription2Routes(hasRole, hasFeature),
      beforeEnter: (to, from, next) => {
        // eslint-disable-next-line no-unused-vars
        next(vm => (hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin') ? true : '/dashboard'))
      },
      meta: {
        authName: 'kppnext'
      }
    },
    {
      path: '/devices',
      name: 'Devices',
      components: {
        default: Devices,
        detail: Device
      },
      children: DeviceRoutes(hasRole, hasFeature),
      beforeEnter: (to, from, next) => {
        // eslint-disable-next-line no-unused-vars
        next(vm => (hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin,Credentialed') ? true : '/dashboard'))
      },
      meta: {
        authName: 'kppnext'
      }
    },
    {
      path: '/groups',
      name: 'Groups',
      components: {
        default: Groups,
        detail: Group
      },
      children: GroupRoutes(hasRole, hasFeature),
      beforeEnter: (to, from, next) => {
        // eslint-disable-next-line no-unused-vars
        next(vm => (hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin,Credentialed') ? true : '/dashboard'))
      },
      meta: {
        authName: 'kppnext'
      }
    },
    {
      path: '/reports',
      component: Reports,
      name: 'reports',
      meta: {
        authName: 'kppnext'
      }
    },
    {
      path: '/api',
      component: Api,
      name: 'api',
      meta: {
        authName: 'kppnext'
      }
    },
    {
      path: '/documentation',
      component: Documentation,
      children: DocumentationRoutes(hasRole, hasFeature),
      beforeEnter: (to, from, next) => {
        next();
        // hasClaim('documentation') ? next() : next('/dashboard');
      },
      meta: {
        authName: 'kppnext'
      }
    },
    {
      path: '/software',
      component: Software,
      children: SoftwareRoutes(hasRole, hasFeature),
      beforeEnter: (to, from, next) => {
        next();
        // hasClaim('software') ? next() : next('/dashboard');
      },
      meta: {
        authName: 'kppnext'
      }
    },
    {
      path: '/admin',
      component: Admin,
      children: AdminRoutes(hasRole, hasFeature),
      beforeEnter: (to, from, next) => {
        // eslint-disable-next-line no-unused-vars
        next(vm => (hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin') ? true : '/dashboard'))
      },
      meta: {
        authName: 'kppnext'
      }
    },
    {
      path: '/jobs',
      name: 'Jobs',
      components: {
        default: Jobs,
        detail: JobPage
      },
      children: JobRoutes(hasRole, hasFeature),
      beforeEnter: (to, from, next) => {
        // next(vm => { return hasPermission('get_devices') ? true : '/dashboard' })
        next();
      },
      meta: {
        authName: 'kppnext'
      }
    },
    {
      path: '/health',
      name: 'Health',
      component: Health,
      meta: {
        authName: 'kppnext'
      },
      beforeEnter: (to, from, next) => {
        // eslint-disable-next-line no-unused-vars
        next(vm => (hasRole('Super User,Kymeta Admin') ? true : '/dashboard'))
      },
    },
    {
      path: '/tools',
      component: Tools,
      name: 'tools',
      children: [
        {
          path: 'optionsFileValidator',
          component: OptionsFileValidator,
          name: 'optionsFileValidator',
          meta: {
            detail: false
          }
        }
      ],
      meta: {
        authName: 'kppnext'
      }
    },
  ]
}
